import { createApp } from 'vue'
import App from './App.vue'
import { setupStore } from './store'
import { setupAntd } from './plugin/antd'
import {setupRouter} from './router'
import "./app.less"
// @ts-ignore
import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css
// 引入组件库的少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';
import TDesign from 'tdesign-vue-next';

import { addI18n } from 'tuikit-atomicx-vue3';
import { enResource, zhResource } from './i18n';

const resizeObserverErrorMessages = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (event) => {
    if (resizeObserverErrorMessages.includes(event.message)) {
        event.stopImmediatePropagation();
    }
});

const app = createApp(App)

function setupPlugins () {
    setupAntd(app)
}

async function setupApp() {
    // 挂载vuex状态管理
    setupStore(app);
    // Multilingual configuration
    // Asynchronous case: language files may be obtained from the server side
    // await setupI18n(app);
    // // 挂载路由
    await setupRouter(app);

    app.use(vue3videoPlay);


    app.mount('#app');
}

app.use(TDesign);

setupPlugins();

setupApp();

addI18n('en-US', { translation: enResource });
addI18n('zh-CN', { translation: zhResource });
